export const Reservation = {
  CardTitle: '予約管理',
  CountUnit: '({0}件)',
  ReceiptIdSTitle: '受付番号:',
  ReservationDateTimeTitle: '予約日時：',
  ReservationExplanation1: '処方箋の事前送信や',
  ReservationExplanation2: 'オンライン服薬指導はこちらから',
  ButtonTitle: 'お薬をもらう予約をする',
  ButtonSubTitle1: '電子処方箋',
  ButtonSubTitle2: '受付可能',
  ReservationName: {
    PrescriptionReception: '予約受付',
    CompoundingMedicine: '調剤中',
    MedicationExplanation: 'お薬の説明',
    CreditPayment: '支払い',
    DeliveryReceipt: '受け取り',
    OnlineReserve: 'オンライン服薬指導（ビデオ通話）',
  },
  Button: {
    ReservationConfirmation: '予約内容を確認する',
    DeliveryConfirmation: '配送状況を確認する',
  },
  Information: {
    Title: '「薬をもらう」に関する機能紹介',
    MedicalInterview: {
      Title: '事前問診',
      Statement: '待ち時間を減らします',
    },
    OnlineMedicationGuide: {
      Title: 'オンライン服薬指導',
      Statement: '自宅から服薬指導を受けられます',
    },
    Delivery: {
      Title: 'お薬の配送',
      Statement: '即日配送（一部）も可能です',
      Schedule: '配送予定日時',
      Check: '配送状況の確認',
      Detail: '詳細を確認する',
      ContactNumber: 'お問い合わせ番号',
      Copy: 'コピー',
      MedicalCoach: '服薬指導',
      DeliveryReady: '出荷準備中',
      DeliveryNow: '配達中',
      DeliveryComplete: '配達完了',
    },
    PaymentMethod: {
      Title: 'アプリでお支払い',
      Statement: 'カード決済も可能です',
    },
    NoLongerAcceptReservations: '本アプリによる調剤予約受付は、\nサービス終了に伴い、\n4月23日をもちまして終了いたしました。',
  },
};
